// extracted by mini-css-extract-plugin
export default {"Time":"yVm62","item":"_2sqhe","item--isDefault":"AmFEP","item--isSelected":"mF7G-","item--isDisabled":"u3DYn","skeleton-progress":"kBy2x"};